import React from 'react';
import { PandaGreeting } from 'shared/images/characters';
import styles from './empty-state.module.scss';
import { usePandaConversation } from '../../panda-chat-provider';

export function EmptyState() {
  const { lang } = usePandaConversation();

  return (
    <div className={styles.root}>
      <img className={styles.image} src={PandaGreeting} alt="" />
      {/* English copy, matching Figma node 83:266. V2 chat is English-only for now. */}
      <p className={styles.title}>{lang.PANDA_EMPTY_TITLE || 'Hi, I’m Panda'}</p>
      <p className={styles.subtitle}>
        {lang.PANDA_EMPTY_SUBTITLE ||
          'Ask about any institutional guideline in plain language. I answer with citations to the exact source.'}
      </p>
    </div>
  );
}
